import { render } from "./AutoComplete.vue?vue&type=template&id=47799844"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=47799844&lang=css"
script.render = render

export default script